import { IGetAllAssistenciaPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/read/get_all_assistencia_pesquisa_satisfacao_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { AssistenciaTecnicaPesquisaLista } from "../../models/assistencia_tecnica_pesquisa_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllAssistenciaPesquisaSatisfacaoUseCase
 */

export class GetAllAssistenciaPesquisaSatisfacaoUseCase
  extends BasePaginatedUseCase<AssistenciaTecnicaPesquisaLista>
  implements IGetAllAssistenciaPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllAssistenciaPesquisaSatisfacao(
    idAssistenciaTecnica: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idAssistenciaTecnica === null) {
      throw new Error('ID da assistência técnica é obrigatório para buscar as pesquisas de satisfação!');
    }

    const result = await this.repository.getAllAssistenciaPesquisaSatisfacao(
      idAssistenciaTecnica,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
